import {AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';
import {TextUtils} from "../../../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-edit-page-tooltip',
    templateUrl: './edit-page-tooltip.component.html',
    styleUrl: './edit-page-tooltip.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EditPageTooltipComponent implements AfterViewInit {
  @Output() addPage: EventEmitter<void> = new EventEmitter<void>();
  @Output() renamePage: EventEmitter<void> = new EventEmitter<void>();
  @Output() deletePage: EventEmitter<void> = new EventEmitter<void>();
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  options = {
    firstSection: [
      {
        title: TextUtils.getText('text_rename'),
        icons: {
          win: [],
          mac: []
        },
        action: (() => this.renamePage.emit()).bind(this)
      },
      {
        title: TextUtils.getText('text_delete'),
        icons: {
          win: [],
          mac: [],
        },
        action: (() => this.deletePage.emit()).bind(this)
      },
    ],
    secondSection: []
  };
  opened: boolean;


  ngAfterViewInit() {
    setTimeout(() => {
      this.opened = true;
    });
  }
}
